const column = [
  {
    title: '商品订单编号',
    key: 'offerOrderId',
    minWidth: 200,
    fixed: 'left',
    align: 'center'
  },
  {
    title: '订单编号',
    key: 'orderId',
    minWidth: 200,
    fixed: 'left',
    align: 'center'
  },
  {
    title: '家长手机',
    key: 'parentPhone',
    minWidth: 130,
    align: 'center'
  },
  {
    title: '学生姓名',
    key: 'studentName',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '学校名称',
    key: 'schoolName',
    minWidth: 250,
    align: 'center'
  },
  {
    title: '年级班级',
    key: 'gradeClassName',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '学期',
    key: 'yearTermName',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '商品状态',
    slot: 'paySts',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '退款状态',
    slot: 'refundSts',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '机构名称',
    key: 'orgName',
    minWidth: 250,
    align: 'center'
  },
  {
    title: '课程资源',
    key: 'defineCourseName',
    minWidth: 150,
    align: 'center'
  },
  {
    title: '商品名称',
    key: 'offerName',
    minWidth: 200,
    align: 'center'
  },
  {
    title: '课程分类',
    key: 'offerTypeName',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '商品分类',
    key: 'productType',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '订单金额(元)',
    key: 'originalFee',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '实收金额(元)',
    key: 'offerFee',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '报名总课时',
    key: 'classroomTotal',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '支付时间',
    key: 'payTime',
    minWidth: 180,
    align: 'center'
  },
  {
    title: '已退金额',
    key: 'refundFee',
    minWidth: 120,
    align: 'center'
  },

  // {
  //   title: '可结算金额',
  //   key: 'settleAmount',
  //   minWidth: 120,
  //   align: 'center'
  // },
  {
    title: '待退款金额',
    key: 'refundPendingFee',
    minWidth: 140,
    align: 'center'
  },
  {
    title: '请假可退款金额',
    key: 'monthLeaveRefundableAmount',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '结算课时',
    key: 'monthSettleTotal',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '结算金额',
    key: 'monthSettleAmount',
    minWidth: 120,
    align: 'center'

  },
  {
    title: '机构应结金额',
    key: 'monthOrgSettleAmountTotal',
    minWidth: 120,
    align: 'center',
    showForSheetIds: true
  },
  {
    title: '机构应结金额(线上)',
    key: 'monthOrgSettleOnlineAmount',
    minWidth: 120,
    align: 'center',
    showForSheetIds: false
  },
  {
    title: '机构应结金额(线下)',
    key: 'monthOrgSettleOfflineAmount',
    minWidth: 120,
    align: 'center',
    showForSheetIds: false
  },
  // {
  //   title: '平台服务费(到账)',
  //   key: 'monthServiceFee',
  //   minWidth: 120,
  //   align: 'center'
  // },
  {
    title: '平台服务费',
    key: 'monthServiceAmountTotal',
    minWidth: 120,
    align: 'center',
    showForSheetIds: true
  },
  {
    title: '平台服务费(线上)',
    key: 'monthServiceOnlineAmount',
    minWidth: 120,
    align: 'center',
    showForSheetIds: false
  },
  {
    title: '平台服务费(线下)',
    key: 'monthServiceOfflineAmount',
    minWidth: 120,
    align: 'center',
    showForSheetIds: false
  },
  // {
  //   title: '其他机构应结金额',
  //   key: 'monthOtherOrgSettleAmount',
  //   minWidth: 120,
  //   align: 'center'
  // },
  // {
  //   title: '退款申请时间',
  //   slot: 'refundCreateTime',
  //   minWidth: 120,
  //   align: 'center'
  // },
  {
    title: '手续费（元）',
    key: 'wxAmt',
    minWidth: 120,
    align: 'center'
  },
  // {
  //   title: '手续费承担方',
  //   key: 'feesForParty',
  //   minWidth: 120,
  //   align: 'center'
  // },
  {
    title: '手续费(平台方)',
    slot: 'platformCommission',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '手续费(机构方)',
    slot: 'merchantCommission',
    minWidth: 120,
    align: 'center'
  },
  {
    title: '退款备注',
    slot: 'refundReason',
    minWidth: 180,
    align: 'center'
  }
];
// 指定 字段 删除表头
function deleteColFun(targets = [], columns) {
  targets.forEach((target) => {
    const key = columns.findIndex((col) => {
      return col.key == target;
    });
    key != -1 && columns.splice(key, 1);
  });
}
export function getColumn(data) {
  const { title, bankType, showTotalData } = data;
  const col = JSON.parse(JSON.stringify(column));

  const targets = [
    'monthLeaveRefundableAmount',
    'monthSettleTotal',
    'monthSettleAmount',
    'monthOrgSettleAmountTotal',
    'monthOrgSettleOnlineAmount',
    'monthOrgSettleOfflineAmount',
    'monthServiceAmountTotal',
    'monthServiceOnlineAmount',
    'monthServiceOfflineAmount'
    // 'monthServiceFee'
    // 'monthOtherOrgSettleAmount'
  ];
  targets.forEach((target) => {
    col.find((item) => {
      return item.key == target;
    })['title'] =
      title +
      col.find((item) => {
        return item.key == target;
      })['title'];

    col.find((item) => {
      return item.key == 'monthSettleAmount';
    })['renderHeader'] = (h, params) => {
      console.log(params, '拿到的数据0---');
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '240' }}, // 提示组件的属性
        [
          h('span', [
            h('span', `${col.find((item) => {
              return item.key == 'monthSettleAmount';
            })['title']}`), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '结算金额汇总不含退款待审批节次、请假可退款节次'
          ) // 提示内容
        ]
      );
    };

    col.find((item) => {
      return item.key == 'refundPendingFee';
    })['renderHeader'] = (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '240' }}, // 提示组件的属性
        [
          h('span', [
            h('span', `${col.find((item) => {
              return item.key == 'refundPendingFee';
            })['title']}`), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '待退款金额 = 待审批金额'
          ) // 提示内容
        ]
      );
    };

    col.find((item) => {
      return item.key == 'monthOrgSettleAmountTotal';
    })['renderHeader'] = (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '240' }}, // 提示组件的属性
        [
          h('span', [
            h('span', `${col.find((item) => {
              return item.key == 'monthOrgSettleAmountTotal';
            })['title']}`), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '机构结算金额=线上结算+线下结算金额的所有之和'
          ) // 提示内容
        ]
      );
    };

    col.find((item) => {
      return item.key == 'monthServiceAmountTotal';
    })['renderHeader'] = (h, params) => {
      return h(
        'Tooltip',
        { props: { placement: 'top', transfer: true, 'max-width': '240' }}, // 提示组件的属性
        [
          h('span', [
            h('span', `${col.find((item) => {
              return item.key == 'monthServiceAmountTotal';
            })['title']}`), // 列名
            h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
          ]),
          h(
            'span',
            {
              slot: 'content'
            },
            '平台服务费=线上服务费+线下服务费的所有之和'
          ) // 提示内容
        ]
      );
    };
  });

  if (bankType == 1) {
    // 'monthOtherOrgSettleAmount'
    //  deleteColFun(['monthServiceFee'], col)
  }
  if (showTotalData) {
    return col.filter(item => {
      return item.showForSheetIds !== false;
    });
  } else {
    return col.filter(item => {
      return item.showForSheetIds !== true;
    });
  }

  // return col;
}
